import React from 'react';
import { ICadConfigCommanParams, ICadConfigurationOption, IFlattenedCadConfig } from 'common/Session';
import store from '../../../../state/store';
import MessagePrompter from '../../../prompts/MessagePrompter';
import { HelpIcon } from '../../../Iconset';

//hardcoded config in case the session has no config
const hardcodedConfig: Array<ICadConfigurationOption> =
[
	{
		"name": "Triangle count reduction",
		"enforce": [],
		"operations":
			[
				{
					"name": "Remove occluded geometries",
					"id": "remove occluded geometries",
					"params": 
					[
						{
							"name": "Level",
							"id": "level",
							"type": "dropdown",
							"options": ["Parts", "Patches", "Polygons"],
							"default": "Parts"
						},
						{
							"name": "Resolution",
							"id": "resolution",
							"type": "dropdown",
							"options": ["Low", "Medium", "High"],
							"default": "low"
						},
						{
							"name": "Sphere count",
							"id": "sphereCount",
							"type": "number",
							"default": "256"
						},
						{
							"name": "fovX",
							"id": "fovX",
							"type": "number",
							"default": "90"
						},
						{
							"name": "Consider Transparent Opaque",
							"id": "considerTransparentOpaque",
							"type": "boolean",
							"default": "false"
						},
						{
							"name": "Adjacency Depth",
							"id": "adjacencyDepth",
							"type": "dropdown",
							"options": ["None", "Adjacent polygons", "Adjacent polygons and their adjacent polygons"],
							"default": "Adjacent polygons"
						}
					]
				},
				{
					"name": "Decimate to quality",
					"id": "decimate to quality",
					"params":
						[
							{
								"name": "Level",
								"id": "level",
								"type": "dropdown",
								"options": ["low", "medium", "high"],
								"default": "medium"
							}
						]
				},
				{
					"name": "Decimate to target (total count)",
					"id": "decimate to target",
					"params":
						[
							{
								"name": "Target count",
								"id": "target",
								"type": "number",
								"default": "100000"
							}
						]
				},
				{
					"name": "Decimate to target (% of original count)",
					"id": "decimate to %",
					"params":
						[
							{
								"name": "Target percentage",
								"id": "target",
								"type": "number",
								"default": "0.1"
							}
						]
				},
				{
					"name": "Re-Tessellate",
					"id": "tesselate",
					"params":
						[
							{
								"name": "Level",
								"id": "level",
								"type": "dropdown",
								"options": ["low", "medium", "high"],
								"default": "medium"
							}
						]
				},
				{
					"name": "Tessellate with custom max sag",
					"id": "tesselate with custom max sag",
					"params":
						[
							{
								"name": "Max sag",
								"id": "maxSag",
								"type": "number",
								"default": "0.1"
							}
						]
				},
				{
					"name": "Remove holes",
					"id": "remove holes",
					"params":
						[
							{
								"name": "Max Diameter",
								"id": "maxDiameter",
								"type": "number",
								"default": "-1"
							}
						]
				},
			]
	},
	{
		"name": "Object editing",
		"enforce": [],
		"operations":
			[
				{
					"name": "Reset transform",
					"id": "reset transform",
					"params": []
				},
				{
					"name": "Explode connected meshes",
					"id": "explode connected meshes",
					"params": []
				},
				{
					"name": "Merge identical materials",
					"id": "merge identical materials",
					"params": []
				},
				{
					"name": "Remove materials",
					"id": "remove materials",
					"params": []
				},
				{
					"name": "Remove UV",
					"id": "remove uv",
					"params": []
				},
				{
					"name": "Automatic UV mapping",
					"id": "automatic uv mapping",
					"params": []
				},
				{
					"name": "Invert faces orientation",
					"id": "invert faces orientation",
					"params": []
				},
				{
					"name": "Create instances by similarity",
					"id": "create instances by similarity",
					"params":
						[
							{
								"name": "Dimensions",
								"id": "dimensions",
								"type": "number",
								"default": "0.98"
							},
							{
								"name": "Polycount",
								"id": "polycount",
								"type": "number",
								"default": "0.98"
							}
						]
				},
			]
	},
	{
		"name": "Object count reduction",
		"enforce": ["ONE_OPERATION_PER_REVISION"],
		"operations":
			[
				{
					"name": "Merge nodes at final hierarchy level",
					"id": "merge at final level",
					"params":
						[
							{
								"name": "Collapse to parent",
								"id": "collapse",
								"type": "boolean",
								"default": "false"
							}
						]
				},
				{
					"name": "Merge nodes at hierarchy level",
					"id": "merge at tree level",
					"params":
						[
							{
								"name": "Level",
								"id": "level",
								"type": "number",
								"default": "4"
							}
						]
				},
				{
					"name": "Merge nodes with shared materials",
					"id": "merge by materials",
					"params": []
				},
				{
					"name": "Delete empty occurrences",
					"id": "delete empty",
					"params": []
				},
				{
					"name": "Merge parts",
					"id": "merge parts",
					"params": []
				},
				{
					"name": "Delete occurrences",
					"id": "delete occurrences",
					"params": []
				},
				{
					"name": "Rename parts and compress tree",
					"id": "rename parts with parent name and compress tree",
					"params": []
				}
			]
	}
]

export function flattenConfig(config?: Array<ICadConfigurationOption>)
{
	const flattened: IFlattenedCadConfig = {
		commandCategories: {},
		commandList: {},
		commandParams: {},
		paramsList: {},
		uniqueGroups: {},
		optionList: {},		
	};

	if(!config) config = hardcodedConfig;

	for (const category of config) 
	{
		const operationsIds = category.operations.map(op => op.id);

		flattened.commandCategories[category.name] = [...operationsIds];

		if(category.enforce && category.enforce.includes('ONE_OPERATION_PER_REVISION'))
		{
			flattened.uniqueGroups[category.name] = [...operationsIds];
		}

		for (const operation of category.operations) 
		{
			flattened.commandList[operation.id] = operation.name;

			if(operation.params && operation.params.length > 0)
			{
				if(!flattened.commandParams[operation.id]) flattened.commandParams[operation.id] = [];
				for(const param of operation.params)
				{
					if(!flattened.paramsList[param.id]) flattened.paramsList[param.id] = param.name;

					const commandParam: ICadConfigCommanParams = 
					{
						display: param.name, 
						id: param.id, 
						type: param.type, 
						default: param.default,
					};

					if(param.type === 'dropdown' && param.options)
					{
						commandParam.options = [];
						for(const option of param.options)
						{
							const optionName = option.charAt(0).toUpperCase() + option.slice(1);

							if(!flattened.optionList[option])
							{
								flattened.optionList[option] = optionName;
							}
							commandParam.options.push({ display: optionName, value: option });
						}
					}

					flattened.commandParams[operation.id].push(commandParam);
				}
			}
		}
	}

	return flattened;
}

export function parseOperations(item)
{
	const flattenedConfig = store.getState().userModule.sessionInfo?.serverOptions.flattenedConfig;
	if(!flattenedConfig) return;

	const operations = JSON.parse(item.operations);
	const output = new Array<JSX.Element>();
	let index = 1;

	if(item.totalPartsBefore && item.totalPolyBefore)
	{
		output.push(<div key={'ocb'}>{`Object count before processing: `}{item.totalPartsBefore}</div>);
		output.push(<div key={'pcb'}>{`Triangle count before processing: `}{item.totalPolyBefore}</div>);
		output.push(<br key={'nlb'}/>);
	}

	for(const operation of operations)
	{
		const command = flattenedConfig.commandList[operation.command];
		let nodes = "";
		let params = ""

		if(operation.nodes && operation.nodes.length > 0)
		{
			nodes = ` on nodes [${operation.nodes}],`;
		}

		if(operation.params)
		{
			const keys = Object.keys(operation.params);
			for(let i = 0; i < keys.length; i++)
			{
				const paramKey = keys[i]
				let param = flattenedConfig.paramsList[paramKey];

				if(param === "Target count" && operation.command === "decimate to %") 
				{
					param = "Target percentage";
				}

				params += ` ${param}: ${flattenedConfig.optionList[operation.params[paramKey]] ?? operation.params[paramKey]}${i === keys.length-1 ? `.` : `,`}`;
			}
		}
		output.push(<div key={index}>{`${index}. `}{command}{nodes}{params}</div>);
		index++;
	}

	if(item.totalPartsAfter && item.totalPolyAfter)
	{
		output.push(<br key={'nla'}/>);
		output.push(<div key={'oca'}>{`Object count after processing: `}{item.totalPartsAfter}</div>);
		output.push(<div key={'pca'}>{`Triangle count after processing: `}{item.totalPolyAfter}</div>);
	}

	return output;
}

export function parseDefaultOperations(item)
{
	const defaultOperations = item.defaultOperations && item.defaultOperations.length > 0 ? item.defaultOperations : []
	const output = new Array<JSX.Element>();

	if(item.totalPartsBefore && item.totalPolyBefore)
	{
		output.push(<div key={'ocb'}>{`Object count before processing: `}{item.totalPartsBefore}</div>);
		output.push(<div key={'pcb'}>{`Triangle count before processing: `}{item.totalPolyBefore}</div>);
		output.push(<br key={'nlb'}/>);
	}

	for(let i = 0; i < defaultOperations.length; i++)
	{
		output.push(<div key={i}>{`${i+1}. `}{defaultOperations[i]}</div>);
	}

	if(item.totalPartsAfter && item.totalPolyAfter)
	{
		output.push(<br key={'nla'}/>);
		output.push(<div key={'oca'}>{`Object count after processing: `}{item.totalPartsAfter}</div>);
		output.push(<div key={'pca'}>{`Triangle count after processing: `}{item.totalPolyAfter}</div>);
	}

	return output;
}

export function containsUnique(operations)
{
	const output = new Array<string>();
	if(!operations)
	{
		return output;
	}

	const uniqueGroups = store.getState().userModule.sessionInfo?.serverOptions.flattenedConfig?.uniqueGroups;
	if(uniqueGroups)
	{
		const groupEntries = Object.entries<any>(uniqueGroups);
		for(const operation of operations)
		{
			const command = operation.command;
			for(const [key, value] of groupEntries)
			{
				if(value.includes(command) && !output.includes(key))
				{
					output.push(key);
				}
			}
		}
	}

	return output;
}

export function getCategories()
{
	return Object.keys(store.getState().userModule.sessionInfo?.serverOptions.flattenedConfig?.commandCategories ?? {});
}

export function getCategory(command: string)
{
	const flattenedConfig = store.getState().userModule.sessionInfo?.serverOptions.flattenedConfig;
	if(!flattenedConfig) return;

	for(const category of Object.keys(flattenedConfig.commandCategories))
	{
		if(flattenedConfig.commandCategories[category].includes(command))
			return category;
	}
}

export function showAdditionalInfo(revisionItem)
{
	const parsedOperations = JSON.parse(revisionItem.operations || {});

	const message = {
		icon : <HelpIcon/>,
		title : revisionItem.revision ? (revisionItem.name + " / " + revisionItem.revision) : revisionItem.name,
		content : parsedOperations.length > 0 ? parseOperations(revisionItem) : parseDefaultOperations(revisionItem),
		actions: [{ label: "Close" }],
	}
	MessagePrompter.showMessage(message);
}